module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-01-46a8249692bea21e53bdbeb0c8663965.svg";